import { useLayoutEffect } from 'react'
import { FlowMetaData } from '../../../@types/types'
import { setCommonTrackingParameters } from '../../../tracking/tracking'
import { useHeyImmoExperimentTracking } from './UseHeyImmoExperimentTracking'
import { useRecommendedPriceExperimentTracking } from './UseRecommendedPriceExperimentTracking'

type UseExperimentTrackingParams = {
  flowMetadata?: FlowMetaData
  hasHeyImmo: boolean
  recommendedPriceEnabled: boolean
}

export function useExperimentTracking({
  flowMetadata,
  hasHeyImmo,
  recommendedPriceEnabled,
}: UseExperimentTrackingParams) {
  const heyImmoTrackingParameters = useHeyImmoExperimentTracking(hasHeyImmo)
  const recommendedPriceTrackingParameters = useRecommendedPriceExperimentTracking(recommendedPriceEnabled)
  const commonExperimentTrackingParameters = heyImmoTrackingParameters ?? recommendedPriceTrackingParameters
  void flowMetadata

  useLayoutEffect(() => {
    if (!commonExperimentTrackingParameters) {
      return
    }

    setCommonTrackingParameters(commonExperimentTrackingParameters)

    return () => {
      setCommonTrackingParameters()
    }
  }, [commonExperimentTrackingParameters])
}
